import {useApi as useBaseApi} from '../../nuxt-base/composables/useApi';
import {failureDetails, safePath} from '../utils/diagnostics/record.js';

// Preserve base auth, retries, transforms and return values. Direct SSR HAPI
// calls (notably redirects) otherwise have no Nuxt proxy trace to correlate.
export function useApi(url, fetchOptions = {}, options = {}) {
	const logger = import.meta.server ? useNuxtApp().$diagnostics : null;
	if (!logger || !/(?:^|\/)hapi\//.test(safePath(url))) return useBaseApi(url, fetchOptions, options);
	const context = logger.context();
	const trace = {proxyEndpoint: safePath(url), endpoint: safePath(url), cache: 'bypassed', attempts: 0, upstreamResponse: 'not_observed', upstreamBody: 'not_observed'};
	let started;
	const publish = () => {
		context.upstreamTraces = (context.upstreamTraces || []).filter(item => item !== trace);
		context.upstreamTraces.push(trace);
		if (context.upstreamTraces.length > 4) context.upstreamTraces.shift();
	};
	const tap = (name, observe) => [observe, ...[fetchOptions[name] || []].flat()];
	return useBaseApi(url, {...fetchOptions,
		onRequest: tap('onRequest', request => {
			started ??= Date.now();
			delete trace.networkCode; delete trace.frames; delete trace.message; delete trace.status;
			trace.attempts++; trace.stage = 'upstream_request'; trace.upstreamStatus = null;
			trace.upstreamResponse = 'not_observed'; trace.upstreamBody = 'not_observed';
			try {trace.upstreamHost = new URL(String(request.request), request.options.baseURL).hostname;} catch {}
			publish();
		}),
		onRequestError: tap('onRequestError', request => {
			Object.assign(trace, failureDetails(request.error));
			trace.stage = 'upstream_network_or_setup'; trace.upstreamResponse = 'not_received';
			trace.upstreamDurationMs = Date.now() - started; publish();
		}),
		onResponse: tap('onResponse', request => {
			trace.upstreamStatus = request.response.status; trace.upstreamResponse = 'received'; trace.upstreamBody = 'complete';
			trace.stage = trace.upstreamStatus >= 400 ? 'upstream_http_error' : 'upstream_success';
			trace.upstreamDurationMs = Date.now() - started; publish();
		}),
	}, options);
}
